import type {
  CanvasNodeType,
  ObjectKind,
  ObjectKindKey,
} from "@/object-actions/types";

const REACT_FLOW_TO_CANVAS_NODE: Record<string, CanvasNodeType> = {
  entity: "entity",
  textNote: "text-note",
  canvasText: "canvas-text",
  canvasShape: "canvas-shape",
  section: "section",
  widgetNode: "widget-node",
  chatSession: "chat-session",
  canvasConnector: "canvas-connector",
  canvasDrawing: "canvas-drawing",
};

export function reactFlowNodeTypeToCanvasNodeType(
  nodeType: string | undefined,
): CanvasNodeType | undefined {
  if (!nodeType) return undefined;
  return REACT_FLOW_TO_CANVAS_NODE[nodeType];
}

export function canvasEntityExtensionKindKey(
  nodeType: CanvasNodeType,
  entityBase: string,
): ObjectKindKey {
  return `canvas-node:${nodeType}:${entityBase.replace(/_/g, "-")}`;
}

export function buildCanvasNodeKind(
  nodeType: string | undefined,
  entityBase?: string,
  entityIsReference?: boolean,
): ObjectKind | null {
  const canvasNodeType = reactFlowNodeTypeToCanvasNodeType(nodeType);
  if (!canvasNodeType) return null;
  return {
    type: "canvas-node",
    nodeType: canvasNodeType,
    entityBase: entityBase?.replace(/_/g, "-"),
    entityIsReference,
  };
}
